/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Works_Seo_DescInputs */

const en_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A showcase of projects built with React, TypeScript, and modern web technologies.`)
};

const ar_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعة أعمال بُنيت بـ React وTypeScript وأحدث تقنيات الويب.`)
};

const bn_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, TypeScript ও আধুনিক ওয়েব টেক দিয়ে তৈরি প্রজেক্টের সংগ্রহ।`)
};

const de_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Präsentation von Projekten, die mit React, TypeScript und modernen Webtechnologien erstellt wurden.`)
};

const es_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una muestra de proyectos creados con React, TypeScript y tecnologías web modernas.`)
};

const fr_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une vitrine de projets construits avec React, TypeScript et les technologies Web modernes.`)
};

const pt_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma vitrine de projetos desenvolvidos com React, TypeScript e tecnologias web modernas.`)
};

const zh_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 React、TypeScript 和现代 Web 技术构建的项目展示。`)
};

const tr_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React, TypeScript ve modern web teknolojileriyle oluşturulmuş projelerin vitrini.`)
};

const ru_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Демонстрация проектов, созданных с использованием React, TypeScript и современных веб-технологий.`)
};

const pl_works_seo_desc = /** @type {(inputs: Works_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentacja projektów zbudowanych w React, TypeScript i nowoczesnych technologiach internetowych.`)
};

/**
* | output |
* | --- |
* | "A showcase of projects built with React, TypeScript, and modern web technologies." |
*
* @param {Works_Seo_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const works_seo_desc = /** @type {((inputs?: Works_Seo_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Works_Seo_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_works_seo_desc(inputs)
	if (locale === "bn") return bn_works_seo_desc(inputs)
	if (locale === "de") return de_works_seo_desc(inputs)
	if (locale === "es") return es_works_seo_desc(inputs)
	if (locale === "fr") return fr_works_seo_desc(inputs)
	if (locale === "pt") return pt_works_seo_desc(inputs)
	if (locale === "zh") return zh_works_seo_desc(inputs)
	if (locale === "tr") return tr_works_seo_desc(inputs)
	if (locale === "ru") return ru_works_seo_desc(inputs)
	if (locale === "pl") return pl_works_seo_desc(inputs)
	return en_works_seo_desc(inputs)
});